// Common chart translations
export default {
  // Series names
  inflow: "Inflow",
  outflow: "Outflow",

  // Y-axis unit
  unitTimes: "Unit: (Times)",
};
